import React from 'react';

function SectionHeading({ label, title, description, alignLeft = false }) {
  const containerStyle = alignLeft ? { textAlign: 'left', margin: '0 0 1.75rem' } : undefined;
  const headingStyle = alignLeft ? { margin: 0 } : undefined;

  return (
    <div className="section-heading" style={containerStyle}>
      <span className="section-label">{label}</span>
      <h3 style={headingStyle}>{title}</h3>
      {description ? <p>{description}</p> : null}
    </div>
  );
}

export default SectionHeading;
